import { VFlow } from 'bold-ui'

import { NewsHeadingSection } from '../components/NewsHeadingSection'
import { NewsListItem } from '../components/NewsListItem'
import { NewsSectionContent } from '../components/NewsSectionContent'

export function NewsInternalEstabilizacaoV55() {
  return (
    <VFlow>
      <NewsHeadingSection title='Versão 5.5.34' id='estabilizacao-5-5-34'>
        <NewsSectionContent>
          <NewsListItem>
            Marcação automática da opção "Nenhuma" no campo "Condição maternal" para crianças menores de 10 anos e
            pessoas idosas a partir de 60 anos no registro de vacinação, que pode ser alterada posteriormente pelo
            profissional.
          </NewsListItem>
          <NewsListItem>
            Ajuste na exibição do nome do profissional nas listagens de consultas e visitas domiciliares em "Últimos
            contatos" no Acompanhamento de pré-natal e puerpério, que passa a apresentar o nome social sem exibir o nome
            civil.
          </NewsListItem>
          <NewsListItem>Atualização da tabela SIGTAP a partir da competência de 09/2026.</NewsListItem>
          <NewsListItem>
            Atualização das regras vacinais para o registro da aplicação do imunobiológico "HPV quadrivalente".
          </NewsListItem>
          <NewsListItem>
            Ajustes de regras na prescrição digital de antimicrobianos com outros medicamentos especiais.
          </NewsListItem>
          <NewsListItem>
            Substituição do CPF pelo registro no conselho de classe do profissional solicitante na impressão de
            solicitações de exames e procedimentos.
          </NewsListItem>
          <NewsListItem>
            Correção da exibição do botão "Ir para o SOAP" no componente de "Ajuda sobre o desfecho da gestação", do
            Acompanhamento de pré-natal, que passa a ser exibido somente quando o acesso é feito pelo SOAP do
            atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção no carregamento de algumas imagens e GIFs no módulo de Novidades da versão.
          </NewsListItem>
          <NewsListItem>
            Correção de erro que podia ocorrer na tela de Acompanhamento de condições de saúde ao selecionar a opção
            "Outra" no filtro "Faixa etária" sem informar idade mínima e máxima.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que o sistema apresentava erro na etapa "Limpeza do fato de cidadão" no processamento
            de relatórios.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.33' id='estabilizacao-5-5-33'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário em que um erro de chave duplicada ocorria durante a etapa de processamento de cidadãos
            vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.32' id='estabilizacao-5-5-32'>
        <NewsSectionContent>
          <NewsListItem>
            Inclusão de novo cartão de "Anexo de arquivos" na folha de rosto e na lateral do atendimento.
          </NewsListItem>
          <NewsListItem>
            Remoção de regra que impedia a unificação de bases em instalações que habilitaram o anexo de arquivos.
          </NewsListItem>
          <NewsListItem>
            Possibilidade de edição dos tipos de serviço, permitindo a seleção de estabelecimentos diferentes para
            diferentes tipos de serviço.
          </NewsListItem>
          <NewsListItem>
            Ajuste na ordem de exibição dos cartões de dose no calendário vacinal para os imunobiológicos Pneumocócica
            10V, Pneumo 20 e Febre Amarela, apresentando a dose de reforço antes da dose única.
          </NewsListItem>
          <NewsListItem>
            Atualização das regras para o registro da aplicação dos imunobiológicos "Vacina hexa acelular
            (DTPa/HB/VIP/Hib)", "Vacina dTpa adulto" e "Vacina pneumo 20".
          </NewsListItem>
          <NewsListItem>
            Atualização das regras de equivalência para as doses D1 e D2 das vacinas "Meningo C" e "Meningo ACWY", tanto
            na aplicação de imunobiológico quanto no relatório da Busca ativa de vacinação.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário que criava registros desnecessários ao parear dispositivos no painel de chamadas.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário na navegação do Cuidado compartilhado, em que a aba "Acompanhamentos" não aparecia
            visualmente selecionada ao acessar a tela de Acompanhamento de pré-natal.
          </NewsListItem>
          <NewsListItem>
            Correção de erros no preenchimento de informações do odontograma no atendimento odontológico.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.31' id='estabilizacao-5-5-31'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário onde as listas temáticas do Acompanhamento de condições de saúde poderiam apresentar
            erro ao consultar com filtro de problemas/condições.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.30' id='estabilizacao-5-5-30'>
        <NewsSectionContent>
          <NewsListItem>
            Atualização do modelo de impressão do PDF do Acompanhamento de pré-natal, garantindo a exibição detalhada
            das informações e a padronização das seções e relatórios do atendimento.
          </NewsListItem>
          <NewsListItem>
            Inclusão dos testes rápidos no bloco de exames do módulo de Acompanhamento de pré-natal, permitindo a
            visualização conforme o trimestre gestacional.
          </NewsListItem>
          <NewsListItem>
            Atualização das regras para o registro da aplicação dos imunobiológicos "Vacina febre amarela", "Vacina
            varíola símia", "Vacina dengue" e "Vacina Chikungunya".
          </NewsListItem>
          <NewsListItem>
            Concessão de acesso ao acompanhamento territorial para o perfil de coordenador da unidade básica de saúde.
          </NewsListItem>
          <NewsListItem>
            Substituição das equipes NASF por equipes eMulti, acarretando na alteração do nome do perfil "Outros
            profissionais de nível superior NASF" para "Outros profissionais de nível superior eMulti".
          </NewsListItem>
          <NewsListItem>
            Atualização do componente de novidades da versão, que agora apresenta os tópicos com opções clicáveis. Ao
            selecionar um tópico, o usuário é direcionado ao assunto correspondente no módulo de Novidades da versão,
            facilitando o acesso ao conteúdo detalhado das novidades.
          </NewsListItem>
          <NewsListItem>Atualização da tabela de procedimentos SIGTAP para a competência de 07/2026.</NewsListItem>
          <NewsListItem>
            Correção de cenário onde o medicamento é duplicado na impressão da prescrição de medicamentos.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde o cartão de medições não era exibido na discussão de caso no módulo de cuidado
            compartilhado.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que ocorria erro ao tentar gerar a impressão do atendimento de procedimentos.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a tabela de fabricantes de imunobiológicos apresentava registros duplicados no
            banco de dados.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que exames com complemento do CDS solicitados não eram contabilizados em exames no
            módulo de Acompanhamento de pré-natal.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a data de registro tardio era exibida incorretamente na impressão de atendimentos
            agendados fora das unidades de saúde.
          </NewsListItem>
          <NewsListItem>
            Correção de erro que impedia a finalização do atendimento ao registrar resultados de exames previamente
            solicitados cujo procedimento foi inativado no sistema. Agora, é possível registrar os resultados pendentes
            e concluir a consulta normalmente.
          </NewsListItem>
          <NewsListItem>
            Correção de um erro que impedia a finalização do atendimento ao preencher a DUM em um atendimento de
            observação onde foi preenchido campos que fazem parte da puericultura.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário que poderia causar travamento durante processamento de relatórios em algumas
            instalações.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.29' id='estabilizacao-5-5-29'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário de chave duplicada durante a etapa de processamento de cidadãos vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.28' id='estabilizacao-5-5-28'>
        <NewsSectionContent>
          <NewsListItem>
            Ajuste no campo de forma farmacêutica, indicando que o usuário deve buscar para selecionar o valor
            correspondente.
          </NewsListItem>
          <NewsListItem>
            Ajustes e adaptações visuais nos componentes da videochamada para correto funcionamento em dispositivos
            móveis.
          </NewsListItem>
          <NewsListItem>
            Ajustado o fluxo de navegação do anfitrião para que, quando por algum motivo ele sair da videochamada, o
            redirecionamento padrão seja sempre para a sala de espera.
          </NewsListItem>
          <NewsListItem>
            Correção de mau funcionamento do botão "Retornar à página anterior" apresentado nas telas de erro.
          </NewsListItem>
          <NewsListItem>
            Correção na exibição da transcrição da caderneta ao imprimir a retificação do atendimento de procedimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a opção de visualizar o Acompanhamento de Pré-natal e Puerpério, na tela de
            Cuidado compartilhado, apresentava erro de página não encontrada.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que a tentativa de visualizar o gráfico de pressão arterial no Acompanhamento de
            pré-natal redirecionava para a aba incorreta.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.27' id='estabilizacao-5-5-27'>
        <NewsSectionContent>
          <NewsListItem>
            Correção de cenário em que não estava sendo possível cadastrar lote de imunobiológico referente à vacina
            para fabricante SINOVAC (DALIAN).
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que o processamento de relatórios apresentava lentidão na etapa de deleção de
            registros.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.26' id='estabilizacao-5-5-26'>
        <NewsSectionContent>
          <NewsListItem>
            Habilitados os botões de "Cancelar atendimento individual" e "Cancelar escuta inicial" na aba de
            Acompanhamento de pré-natal.
          </NewsListItem>
          <NewsListItem>
            Implementado o fluxo de reconexão automática (com tempo máximo de 1 minuto) durante a videochamada, com
            aviso visual ao usuário e direcionamento para tela de erro caso a conexão não seja restabelecida.
          </NewsListItem>
          <NewsListItem>
            Implementada uma mensagem de aviso que informa ao usuário quando ocorrer instabilidade na conexão durante a
            videochamada ou em suas etapas de acesso.
          </NewsListItem>
          <NewsListItem>
            Inclusão de alerta ao prescrever Insulina NPH indicando as novas recomendações do SUS para alterar o
            tratamento para Insulina Glargina.
          </NewsListItem>
          <NewsListItem>
            Novo item de "PNCT Manutenção" incluído nas Práticas em saúde do registro de Atividade coletiva.
          </NewsListItem>
          <NewsListItem>
            Depreciação do CNS e priorização do CPF, tendo este como dado único do cidadão nas Fichas de avaliação de
            Elegibilidade no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção do cálculo da pontuação das perguntas 14 e 18 referentes à Entrevista de Seguimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que não era possível excluir um cidadão da lista de atendimentos após ele ser chamado
            no painel de chamadas.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário em que ao identificar problemas e condições do histórico de diabetes ou hipertensão com
            código AB, impossibilitava a finalização do atendimento.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde algumas vacinas apresentadas no histórico de atendimentos não eram consideradas na
            lista temática de saúde da mulher no Acompanhamento de condições de saúde.
          </NewsListItem>
          <NewsListItem>Correção na fila de requisições para o CADSUS.</NewsListItem>
          <NewsListItem>
            Correção de cenário em que não estava sendo possível realizar a atualização de algumas bases devido a um
            erro de processamento de vínculo no Acompanhamento de cidadãos vinculados.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.25' id='estabilizacao-5-5-25'>
        <NewsSectionContent>
          <NewsListItem>
            Inclusão do item Fornecimento de kit bucal no campo Práticas em saúde da Atividade coletiva, também
            disponível nos relatórios de produção e em seus filtros personalizados.
          </NewsListItem>
          <NewsListItem>
            Depreciação do CNS e priorização do CPF, tendo este como dado único do cidadão nas Fichas de atividade
            coletiva no CDS.
          </NewsListItem>
          <NewsListItem>
            Passa a ser permitida a inclusão de atendimentos de Escuta inicial na impressão em lote do Histórico clínico
            do cidadão, gerando um único PDF com os registros selecionados.
          </NewsListItem>
          <NewsListItem>
            Atualização da base de endereços do sistema, mantendo os dados de localidades em conformidade com a versão
            de 2026.
          </NewsListItem>
          <NewsListItem>Atualização da tabela de procedimentos SIGTAP para a competência de 06/2026.</NewsListItem>
          <NewsListItem>
            Correção de cenário em que o sistema bloqueava a importação de fichas com procedimentos de código AB em
            problemas/condições.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde atendimentos de Pré-natal, Puericultura e Puerpério realizados no CDS não
            apresentavam a devida classificação no histórico.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.24' id='estabilizacao-5-5-24'>
        <NewsSectionContent>
          <NewsListItem>
            Ajuste de erro em que alguns imóveis não estavam sendo exibidos corretamente no CDS.
          </NewsListItem>
          <NewsListItem>
            Correção de cenário onde não estava sendo possível realizar a atualização do sistema em algumas instalações.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
      <NewsHeadingSection title='Versão 5.5.23' id='estabilizacao-5-5-23'>
        <NewsSectionContent>
          <NewsListItem>
            Reorganização do acesso aos módulos de Cadastro individual e Acompanhamento do território.
          </NewsListItem>
          <NewsListItem>Criação do novo perfil padrão no e-SUS com o nome Mediador intercultural.</NewsListItem>
          <NewsListItem>
            Inclusão de informações complementares dos fabricantes de vacinas para facilitar sua identificação nos
            registros de vacinação.
          </NewsListItem>
          <NewsListItem>Inclusão do campo CID-10 no módulo de Antecedentes familiares.</NewsListItem>
          <NewsListItem>Reorganização no fluxo de configuração do painel de chamadas.</NewsListItem>
          <NewsListItem>
            Atualização das regras de faixa etária e aprazamento para o registro da aplicação do imunobiológico "Pneumo
            20".
          </NewsListItem>
          <NewsListItem>
            Atualização dos campos e regras de validação para suportar o novo formato de CNPJ alfanumérico, em
            conformidade com a Instrução Normativa 2.229 da Receita Federal.
          </NewsListItem>
          <NewsListItem>
            Priorização do CPF como chave principal do cidadão no Atendimento Domiciliar e no Cadastro Domiciliar e
            Territorial do CDS, tornando o preenchimento do CNS habilitado apenas se o cidadão não possuir CPF.
          </NewsListItem>
          <NewsListItem>
            Correção de erro na Lista de atendimentos em que a equipe responsável não era carregada ao editar um
            atendimento.
          </NewsListItem>
        </NewsSectionContent>
      </NewsHeadingSection>
    </VFlow>
  )
}
